import { useEffect, Component } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Lenis from "lenis";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import StudioPage from "@/pages/StudioPage";
import NotFound from "@/pages/NotFound";
import { SiteLayout } from "@/components/SiteLayout";
import { LanguageProvider } from "@/i18n/LanguageContext";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-void text-white flex items-center justify-center font-body">
          <p className="text-white/60">Something went wrong. Refresh the page.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function SmoothScroll() {
  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return null;
}

export default function App() {
  return (
    <ErrorBoundary>
      <SmoothScroll />
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/admin" element={<Admin />} />
            <Route element={<SiteLayout />}>
              <Route path="/" element={<Landing />} />
              {["work", "services", "studio", "contact"].map(page => <Route key={page} path={`/${page}`} element={<StudioPage page={page} />} />)}
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
      <Toaster position="bottom-right" theme="dark" />
    </ErrorBoundary>
  );
}
